import React, { useEffect, useState } from 'react';
import { Button, Col, Layout, Row, Typography } from 'antd';
import GreetingsTop from '../../../../components/Admin/GreetingsTop/GreetingsTop';
import useUser from '../../../../hooks/useUser';
import SupplierOperationsTable from '../../../../components/Admin/Suppliers/SupplierOperations/SupplierOperations';
import { ContainerOutlined } from '@ant-design/icons';
import { getAllOperationsApi } from '../../../../api/operations';
import useDataGeneral from '../../../../hooks/useDataGeneral';
import Modal from '../../../../components/General/Modal';
import AddPurchaseOrder from '../../../../components/Admin/Billling/AddPurchaseOrder/AddPurchaseOrder';
import UploadSupplierBillings from '../../../../components/Admin/Suppliers/SupplierOperations/UploadSupplierBillings';

export default function SuplierOperations() {
  const { person } = useUser();
  const { statusData, reset } = useDataGeneral();
  const [modalIsVisible, setModalIsVisible] = useState(false);
  const [titleModal, setTitleModal] = useState(false);
  const [contextModal, setContextModal] = useState(null);
  const [keysSelected, setKeysSelected] = useState([]);
  const [operations, setOperations] = useState([]);
  const [reloadOperations, setReloadOperations] = useState(true);

  const showModal = () => {
    setModalIsVisible(true);
    setTitleModal('Generar facturas');
    setContextModal(
      <UploadSupplierBillings
        setModalIsVisible={setModalIsVisible}
        operationIds={keysSelected}
        operations={operations}
        setReloadOperations={setReloadOperations}
      ></UploadSupplierBillings>
    );
  };

  return (
    <Layout>
      <GreetingsTop />

      <HeaderTop showModal={showModal} keysSelected={keysSelected} />

      <div className="clients__container">
        <SupplierOperationsTable 
          operations={operations}
          operationIds={keysSelected}
          setKeysSelected={setKeysSelected}
          showModal={showModal}
          reloadOperations={reloadOperations}
          setReloadOperations={setReloadOperations}/>
      </div>
      <Modal
        title={titleModal}
        visible={modalIsVisible}
        setIsVisible={setModalIsVisible}
        width={1000}
      >
        {contextModal}
      </Modal>
    </Layout>
  );
}

function HeaderTop({ showModal, keysSelected }) {
  const { Title } = Typography;
  const { person } = useUser();

  return (
    <div className="clients__container">
      <Row className="header-top" justify="space-between" align="middle">
  <Col className="header-top__left">
    <Title level={3}>Operaciones {person.name}</Title>
  </Col>
  <Col>
    <Button
      onClick={() => showModal('addFile')}
      className="btn-download"
      disabled={keysSelected.length === 0}
      icon={<ContainerOutlined />}
      style={{ width: 220 }}
    >
      Facturar Operaciones
    </Button>
  </Col>
</Row>

    </div>
  );
}
